import React, { PropsWithChildren } from 'react';
import { matchPath, Navigate, useLocation } from 'react-router-dom';
import { useGuestState } from './GuestProvider';

const guestAllowedPaths = [
  '/',
  '/home',
  '/api-docs',
  '/docs',
  '/docs/:namespace/:kind/:name/*',
  '/catalog/:namespace/api/*',
  '/settings/*',
];

export const isGuestAllowedPath = (pathname: string) =>
  guestAllowedPaths.some(pattern => matchPath(pattern, pathname));

export const GuestRouteGuard = ({ children }: PropsWithChildren<{}>) => {
  const { isGuest, loading } = useGuestState();
  const { pathname } = useLocation();

  if (isGuestAllowedPath(pathname) || (!loading && !isGuest)) {
    return <>{children}</>;
  }

  if (loading) {
    return null;
  }

  return <Navigate to="/home" replace />;
};
